export default __webpack_public_path__ + "static/media/termica.2eeef25c.png";